import { checkIfFileExists, checkIfFolderExists, getLogger } from '@hashnode/file-parsing'
import fs from 'fs'
import path from 'path'

const logger = getLogger()

export function generateConfigurationFileAndFolderPaths(cwd: string) {
	// Define the folder and file paths
	const folderPath = path.join(cwd, '.hashnode')
	const filePath = path.join(folderPath, 'settings.json')

	return { folderPath, filePath }
}

export function createConfigurationFolder(cwd: string) {
	// Define the folder and file paths
	const { folderPath, filePath } = generateConfigurationFileAndFolderPaths(cwd)
	// Check if the folder exists
	if (!checkIfFolderExists(folderPath)) {
		// Create the folder
		fs.mkdirSync(folderPath, { recursive: true })
		logger.debug(`Folder created: ${folderPath}`)
	} else {
		logger.debug(`Folder already exists: ${folderPath}`)
	}

	// Check if the file exists
	if (!checkIfFileExists(filePath)) {
		// Create the file with some initial content
		fs.writeFileSync(filePath, `{}`, 'utf8')
		logger.debug(`File created: ${filePath}`)
	} else {
		logger.debug(`File already exists: ${filePath}`)
	}
}
